// view matrix
export const HIT_VIEW_MATRIX = "HIT_VIEW_MATRIX";
export const GET_VIEW_MATRIX = "GET_VIEW_MATRIX";

export const GET_VIEW_MATRIX_FOCUS = "GET_VIEW_MATRIX_FOCUS";
// list periode
export const HIT_LIST_PERIOD = "HIT_LIST_PERIOD";
export const GET_LIST_PERIOD = "GET_LIST_PERIOD";
// create
export const HIT_CREATE_MATRIX = "HIT_CREATE_MATRIX";
export const GET_CREATE_MATRIX = "GET_CREATE_MATRIX";
// structure status
export const HIT_MATRIX_STRUCTURE_STATUS = "HIT_MATRIX_STRUCTURE_STATUS";
export const GET_MATRIX_STRUCTURE_STATUS = "GET_MATRIX_STRUCTURE_STATUS";
// set closed status
export const HIT_CLOSED_MATRIX = "HIT_CLOSED_MATRIX";
export const GET_CLOSED_MATRIX = "GET_CLOSED_MATRIX";
// change matrix
export const HIT_CHANGE_MATRIX = "HIT_CHANGE_MATRIX";
export const GET_CHANGE_MATRIX = "GET_CHANGE_MATRIX";
// merge
export const HIT_MERGE_MATRIX = "HIT_MERGE_MATRIX";
export const GET_MERGE_MATRIX = "GET_MERGE_MATRIX";

export const GET_LIST_CONFLICT = "GET_LIST_CONFLICT";
export const HIT_LIST_CONFLICT = "HIT_LIST_CONFLICT";
// pivot
export const HIT_PIVOT_DATA = "HIT_PIVOT_DATA";
export const GET_PIVOT_DATA = "GET_PIVOT_DATA";

// new matrix
export const HIT_NEW_VIEW_MATRIX = "HIT_NEW_VIEW_MATRIX";
export const GET_NEW_VIEW_MATRIX = "GET_NEW_VIEW_MATRIX";

// import matrix
export const HIT_IMPORT_MATRIX = "HIT_IMPORT_MATRIX";

export const GET_MATRIX_STATUS = "GET_MATRIX_STATUS";

// MATRIX V2
export const GET_MATRIX_VIEW_PROCESS = "GET_MATRIX_VIEW_PROCESS";
export const HIT_MATRIX_VIEW_PROCESS = "HIT_MATRIX_VIEW_PROCESS";

export const GET_MATRIX_VIEW_STRUCTURE = "GET_MATRIX_VIEW_STRUCTURE";
export const HIT_MATRIX_VIEW_STRUCTURE = "HIT_MATRIX_VIEW_STRUCTURE";

export const GET_MATRIX_ACTIVE_PERIOD = "GET_MATRIX_ACTIVE_PERIOD";

export const GET_VIEW_MATRIX_FOCUS_CHANGE = "GET_VIEW_MATRIX_FOCUS_CHANGE";

export const HIT_SELECTED_MATRIX_FOCUS = "HIT_SELECTED_MATRIX_FOCUS";
export const GET_SELECTED_MATRIX_FOCUS = "GET_SELECTED_MATRIX_FOCUS";

export const GET_VIEW_DETAIL_OF_PROCESS = "GET_VIEW_DETAIL_OF_PROCESS";
export const HIT_VIEW_DETAIL_OF_PROCESS = "HIT_VIEW_DETAIL_OF_PROCESS";
